import { useNavigate } from 'react-router-dom';

export const PaymentsBanner = () => {
  const navigate = useNavigate();

  return (
    <div
      className='bg-red-200 p-3 mt-2 md:p-4 w-full flex flex-col md:flex-row items-center justify-center md:justify-between shadow-md'
      role='alert'
    >
      <p className='mb-2 md:mb-0 md:mr-4 text-center md:text-left text-sm sm:text-base'>
        Sie haben offene Zahlungen, die Ihre Aufmerksamkeit erfordern.
      </p>
      <button
        onClick={() => navigate('/payments')}
        className='bg-white hover:bg-red-300 hover:text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-600 focus:ring-white transition-colors duration-150 ease-in-out whitespace-nowrap text-sm sm:text-base'
      >
        Zahlungen
      </button>
    </div>
  );
};
